import React, { useRef } from 'react';
import { Select, SelectItem } from '@carbon/react';
import ReactHlsPlayer from 'react-hls-player';
import { MultiviewChannel, PlayerSlot } from './ComplianceMonitoring.types';

interface PlayerGridProps {
  playerSlots: PlayerSlot[];
  channels: MultiviewChannel[];
  channelByPlayer: Record<string, string>;
  onChannelChange: (id: string, value: string) => void;
}

const StreamPlayer: React.FC<{ src: string; name: string }> = ({ src, name }) => {
  const playerRef = useRef<HTMLVideoElement>(null);

  if (!src) {
    return <div className="compliance-player__empty">No channels configured</div>;
  }

  return (
    <ReactHlsPlayer
      key={src}
      playerRef={playerRef}
      src={src}
      aria-label={name}
      autoPlay
      muted
      controls
      playsInline
      preload="none"
      width="100%"
      height="auto"
    />
  );
};

const PlayerGrid: React.FC<PlayerGridProps> = ({
  playerSlots,
  channels,
  channelByPlayer,
  onChannelChange,
}) => {
  return (
    <div className="compliance-player__grid">
      {playerSlots.map((slot) => (
        <div className="compliance-player__card" key={slot.id}>
          <div className="compliance-player__video">
            <StreamPlayer
              src={channelByPlayer[slot.id] ?? ''}
              name={channels.find((channel) => channel.url === channelByPlayer[slot.id])?.name ?? slot.name}
            />
          </div>

          <div className="compliance-player__controls">
            <Select
              id={`channel-select-${slot.id}`}
              labelText="Channel"
              hideLabel
              value={channelByPlayer[slot.id]}
              onChange={(e) => onChannelChange(slot.id, e.target.value)}
              size="sm"
              disabled={channels.length === 0}
            >
              {channels.length === 0 && <SelectItem value="" text="No channels configured" />}
              {channels.map((channel) => (
                <SelectItem key={channel.url} value={channel.url} text={channel.name} />
              ))}
            </Select>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PlayerGrid;
